<template>
    <div class="map-content">
<!--        <el-autocomplete
            class="inp"
            popper-class="my-autocomplete"
            v-model="state"
            :fetch-suggestions="searchAddr"
            placeholder="请输入地址"
            :trigger-on-focus="false"
            @select="handleSelect"
        >
           <i class="el-icon-location-outline el-input__icon" slot="suffix" title="选择地址"></i>
            <template slot-scope="{ item }">
                <div class="name">{{ item.name }}</div>
                <span class="addr" v-if="item.address.length > 0">{{ item.district }}{{ item.address }}</span>
                <span class="addr" v-else>{{ item.district }}</span>
            </template>
        </el-autocomplete> -->
        <div class="map-show" id="map-show"></div>
        <ul id="marker-list" class="marker-list"></ul>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
// import AMap from 'AMap';
var map, marker;
export default {
    name: 'ShowMaps',
    props: {
        mapsData: {
            type: Array
        },
        locationFieldArry: {
            type: Array
        }
    },
    data () {
        return {
            // mapsData: {
            //     longitude: '',
            //     latitude: '',
            //     clockArea: '',
            //     nearestPOI: '',
            //     nearestJunction: '',
            //     nearestRoad: '',
            //     address: ''

            // },
            searchContent: '',
            restaurants: [],
            state: '',
            cacheMap: new Map()
        };
    },
    mounted () {
        let cur = cloneDeep(this.mapsData);
        if (this.locationFieldArry.length > 0) {
            let markArray = [];
            for (let i = 0; i < this.locationFieldArry.length; i++) {
                let field = cloneDeep(this.locationFieldArry[i]);
                let id = field.id + '-view';
                cur.forEach(item => {
                    if (!this.cacheMap.has(item.id)) {
                        let obj = item[id];
                        if (obj) {
                            let mapObj = JSON.parse(obj);
                            let markArrayItem = {id: item.id, position: [mapObj.longitude, mapObj.latitude], desc: mapObj.nearestPOI, rowData: item};
                            console.log(markArrayItem);
                            markArray.push(markArrayItem);
                            this.cacheMap.set(item.id, item);
                        }
                    }
                });
            }
            this.initShowMap(markArray);
        }
    },
    created () {
        console.log(this.locationFieldArry);
        console.log(this.mapsData);
    },
    methods: {
        // searchAddr (queryString, cb) {
        //     var _this = this;
        //     AMap.plugin('AMap.Autocomplete', () => {
        //         let autoOptions = {
        //             city: '全国'
        //         };
        //         let autoComplete = new AMap.Autocomplete(autoOptions); // 初始化autocomplete
        //         autoComplete.search(queryString, (status, result) => {
        //             if (result.info === 'OK') {
        //                 _this.restaurants = result.tips;
        //                 cb(_this.restaurants);
        //             }
        //         });
        //     });
        // },
        initShowMap (markArray) {
            // let map = new AMap.Map('map-show', {
            //     resizeEnable: true,
            //     center: [116.397428, 39.90923],
            //     zoom: 9
            // });
            // let _this = this;
            // AMapUI.loadUI(['misc/MarkerList'], function (MarkerList) {
            //     var markerList = new MarkerList({
            //         map: map,
            //         listContainer: 'marker-list',
            //         // getDataId: function (dataItem, index) {
            //         //     // 返回数据项的Id
            //         //     return dataItem.id;
            //         // },
            //         getPosition: function (dataItem) {
            //             // 返回数据项的经纬度，AMap.LngLat实例或者经纬度数组
            //             return dataItem.position;
            //         },
            //         getMarker: function (dataItem, context, recycledMarker) {
            //             // let content = '标注: ' + (context.index + 1) + '',
            //             let label = {
            //                 offset: new AMap.Pixel(16, 18),
            //                 content: ''
            //             };

            //             if (recycledMarker) {
            //                 // 存在可回收利用的marker,直接setLabel返回
            //                 recycledMarker.setLabel(label);
            //                 return recycledMarker;
            //             }
            //             // 返回一个新的Marker
            //             return new AMap.Marker({
            //                 label: label
            //             });
            //         },
            //         getInfoWindow: function (dataItem, context, recycledInfoWindow) {
            //             _this.$emit('handleNavModelFormEdit', dataItem.rowData);
            //             // var tpl = '<p><%- dataItem.id %>：<%- dataItem.desc %><p>';
            //             var tpl = '<p><%- dataItem.desc %><p>';
            //             // MarkerList.utils.template支持underscore语法的模板
            //             var content = MarkerList.utils.template(tpl, {
            //                 dataItem: dataItem,
            //                 dataIndex: context.index
            //             });
            //             if (recycledInfoWindow) {
            //                 // 存在可回收利用的infoWindow, 直接setContent返回
            //                 recycledInfoWindow.setContent(content);
            //                 return recycledInfoWindow;
            //             }
            //             // 返回一个新的InfoWindow
            //             return new AMap.InfoWindow({
            //                 offset: new AMap.Pixel(0, -23),
            //                 content: content
            //             });
            //         },
            //         getListElement: function (dataItem, context, recycledListElement) {
            //             // var tpl = '<p><%- dataItem.id %>：<%- dataItem.desc %><p>';
            //             var tpl = '<p><%- dataItem.desc %><p>';
            //             var content = MarkerList.utils.template(tpl, {
            //                 dataItem: dataItem,
            //                 dataIndex: context.index
            //             });
            //             if (recycledListElement) {
            //                 // 存在可回收利用的listElement, 直接更新内容返回
            //                 recycledListElement.innerHTML = content;
            //                 return recycledListElement;
            //             }
            //             // 返回一段html，MarkerList将利用此html构建一个新的dom节点
            //             return '<li>' + content + '</li>';
            //         }
            //     });
            //     markerList.render(markArray);
            // });
        },
        handleSelect (item) {
            if (item.id === '') {
                this.$message.error('请选择详细地址');
            } else {
                this.state = item.name;
                this.mapsData.longitude = item.location.lng;
                this.mapsData.latitude = item.location.lat;
                this.$emit('getMapsData', this.mapsData);
                let center = [item.location.lng, item.location.lat];
                this.initShowMap(center);
            }
        },
        geCurrentPosi () {
            // var _this = this;
            // var map = new AMap.Map('container', {
            //     resizeEnable: true
            // });
            // AMap.plugin('AMap.Geolocation', function () {
            //     var geolocation = new AMap.Geolocation({
            //         enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            //         timeout: 5000 // 超过10秒后停止定位，默认：5s
            //     });
            //     map.addControl(geolocation);
            //     geolocation.getCurrentPosition(function (status, result) {
            //         if (status === 'complete') {
            //             let center = [result.position.lng, result.position.lat];
            //             _this.initShowMap(center);
            //         } else {
            //             // console.log(result);
            //             // 定位失败默认当前位置为首都
            //             let center = [116.405285, 39.904989];
            //             _this.initShowMap(center);
            //         }
            //     });
            // });
        },
        // 实例化点标记
        addMarker (arriveCoor) {
            // let _this = this;
            // marker = new AMap.Marker({
            //     icon: '', // 图片ip
            //     imageSize: '20px',
            //     position: arriveCoor,
            //     offset: new AMap.Pixel(-13, -30),
            //     // 设置是否可以拖拽
            //     draggable: true,
            //     cursor: 'move',
            //     // 设置拖拽效果
            //     raiseOnDrag: true
            // });
            // marker.setMap(map);
        }
    }
};
</script>

<style lang="less">
.form-show-map{
    height: 90vh;
    .el-dialog__body{
        height: 80vh;
       .map-content{
           display: flex;
           width: 100%;
           height: 79vh;
           .map-show{
               flex: 1;
               height: 77vh;
           }
           .marker-list{
               width: 20vw;
               list-style: none;
               overflow: auto;
               .amap-ui-markerlist-list-ele{
                  height: 60px;
                  line-height: 60px;
                  cursor: pointer;
                  padding-left: 10px;
                  background-color: #F1F1F1;
               }
               .selected{
                  background-color: #008000;
                  color: #FFFFFF;
               }
           }
       }
    }
}
.amap-copyright,
.amap-logo {
    display: none !important;
}
.inp {
    width: 100%;
}
.my-autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FieldProps/ShowMaps.vue